import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPaintBrush = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.053 21a1.894 1.894 0 0 1-1.895-1.894v-2.843a1.894 1.894 0 1 1 3.789 0v2.843a1.894 1.894 0 0 1-1.894 1.895"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.684 5.842a2.843 2.843 0 0 1 0 5.685h-3.79a2.84 2.84 0 0 0-2.841 2.841"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.843 8.684H6.317a2.842 2.842 0 0 1 0-5.684h8.526a2.842 2.842 0 0 1 0 5.684"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPaintBrush);
export default ForwardRef;
